import React from 'react';

import Dropdown from '@hpstellar/core/Dropdown';

import SearchSort, { TrackSort } from '../../search-filter/components/search-sort';
import { withError } from '../../shared/components/error-boundary';

class VWASort extends React.PureComponent {
    sortChange = (setSort, options) => value => {
        const { field, order } = options[value.index] || {};
        setSort({ field, order });
    };

    render() {
        const { sortOptions } = this.props;
        return (
            <TrackSort>
                {({ trackSort }) => (
                    <SearchSort options={sortOptions} onSort={trackSort}>
                        {({ options, value, setSort }) => {
                            return (
                                <Dropdown
                                    className='sortDropdown'
                                    options={options}
                                    onChange={this.sortChange(setSort, options)}
                                    label='Sort by'
                                    defaultValue={value.value}
                                />
                            );
                        }}
                    </SearchSort>
                )}
            </TrackSort>
        );
    }
}

export default withError(VWASort);
